import { Suspense } from 'react';
import { LoadingPage } from '@/components/loading-page';
import { validateRouteRole } from '@/lib/routing';
import { isStudent } from '@airreading/common';
import { createFileRoute } from '@tanstack/react-router';
import { InfoPage } from '@/components/info-page';
import { InfoCard } from '@/components/info-card';
import { InfoKeyValue } from '@/components/info-key-value';
import { useSuspenseQuery } from '@tanstack/react-query';
import { getMe } from '@/lib/api-calls';

export const Route = createFileRoute('/_layout/account/')({
  beforeLoad: validateRouteRole(isStudent),
  component: Page,
});

function Page() {
  return (
    <Suspense fallback={<LoadingPage />}>
      <MyAccount />
    </Suspense>
  );
}

function MyAccount() {
  const { data: profile } = useSuspenseQuery(getMe());

  const { fullNameOrEmail, firstName, lastName, email, timeZone } = profile;
  const name = firstName && lastName ? `${firstName} ${lastName}` : fullNameOrEmail;

  return (
    <InfoPage
      headerText={name}
      breadcrumbs={{
        linkItems: [
          {
            label: 'Account',
            link: {
              to: '/account',
            },
          },
        ],
        currentPage: name,
        'data-testid': 'account-breadcrumb',
      }}
      data-testid="account-page-header"
    >
      <InfoCard headerText="Account" data-testid="account-card-header">
        <InfoKeyValue label="Name" value={name} data-testid="account-name" />
        <InfoKeyValue label="Account Email" value={email} data-testid="account-email" />
        <InfoKeyValue label="Time Zone" value={timeZone} data-testid="account-timezone" />
      </InfoCard>
    </InfoPage>
  );
}
